<template>
    <!-- eslint-disable vue/no-v-html -->
    <span v-html="line" />
    <!-- eslint-enable -->
</template>
<script setup>
    import { computed, defineProps } from 'vue';

    const props = defineProps({
        text: {
            type: String,
            default: null
        }
    });

    const line = computed(() => formatLine(props.text));

    function formatLine(line) {
        if (line === '') {
            return '<br>';
        }
        return line;
    }
</script>